/* eslint-disable prettier/prettier */
export default {
    language: 'en-US',
    upload_image: 'Upload Image',
    adjust_image: 'Adjust Image',
    preview_image: 'Preview Image',
    view_image_guidelines: 'View Image Guidelines',
    cancel_button: 'Cancel',
    back_button: 'Back',
    next_button: 'Next',
    save_button: 'Save',
    accepted_file_type: 'Accepted file types: JPG, PNG, SVG',
    min_resolution: 'Minimum resolution: {{uploadImageMinWidth}} x {{uploadImageMinHeight}}',
    max_file_size: 'Maximum file size: 2GB',
    drag_and_drop_to_upload: 'Drag and drop a file to upload',
    or: 'or',
    select_file: 'Select File',
    file_type_error: 'Please upload a valid file type.',
    file_dimension_error: "Please select an image with the minimum resolution of \n    {{uploadImageMinWidth}} x {{uploadImageMinHeight}}",
};
